export var revenueActiveLoansMapper = function (response) {
    if (response) {
        return {
            requestId: response.requestid,
            success: response.success,
            message: response.message,
            statusCode: response.statuscode,
            errors: response.errors,
            currentPage: response.currentpage,
            pageSize: response.pagesize,
            totalPages: response.totalpages,
            totalItems: response.totalitems,
            orderBy: response.orderby,
            orderByDesc: response.orderbydesc,
            data: response.data.length > 0
                ? response.data.map(function (item) {
                    return {
                        loancode: item.loancode,
                        loantype: item.loantype,
                        startdate: item.startdate,
                        roi: item.roi,
                        sanctionamt: item.sanctionamt,
                        mvcollaterals: item.mvcollaterals,
                        gdpower: item.gdpower,
                        outledgerbal: item.outledgerbal,
                        ndpower: item.ndpower,
                        shortfall: item.shortfall,
                        actypeflag: item.actypeflag,
                        esoplasLinks: item.esoplasLinks,
                    };
                })
                : [],
        };
    }
    return {};
};
